import React, { useState, useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchCancelReasons, submitCancelReason } from "../../../Providers/cancelReasonProvider"; 

const ReasonPopup = ({ onClose }) => {
    const navigate = useNavigate();
    const [options, setOptions] = useState([]); // Store cancellation reasons
    const [selected, setSelected] = useState([]);
    const [otherReason, setOtherReason] = useState("");
    const popupRef = useRef(null);

    // Fetch cancellation reasons on mount
    useEffect(() => {
        const fetchReasons = async () => {
            try {
                const response = await fetchCancelReasons();
                if (response?.data) {
                    setOptions(response.data);
                } else {
                    console.error("Failed to fetch cancellation reasons");
                }
            } catch (error) {
                console.error("Error fetching cancellation reasons:", error);
            }
        };
        fetchReasons();
    }, []);

    // Handle clicks outside the popup to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    // Handle checkbox selection
    const handleCheckboxChange = (option) => {
        setSelected((prev) =>
            prev.includes(option) ? prev.filter((item) => item !== option) : [...prev, option]
        );
    };

    // Handle order cancellation
    const handleCancelAndExit = async () => {
        if (selected.length === 0) {
            alert("Please select a reason before exiting.");
            return;
        }
    
        if (selected.includes("Other") && otherReason.trim() === "") {
            alert("Please specify your reason in the text field.");
            return;
        }
    
        try {
            const reasonData = selected.includes("Other")
                ? [...selected.filter(r => r !== "Other"), otherReason]
                : selected;
    
            console.log("Submitting reason data:", { reason: reasonData }); // Debugging
    
            const response = await submitCancelReason(reasonData);
            
            if (response.error) {
                console.error("Submission error:", response.error);
            } else {
                onClose();
                navigate("/cart");
            }
        } catch (error) {
            console.error("Error submitting cancellation reason:", error);
        }
    };
    
    

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-scroll backdrop-blur-sm rounded px-10">
            <div className="bg-tertiary py-5 px-11 md:py-10 md:px-14 rounded md:w-[90%] xl:w-[60%] relative top-16 md:top-10 text-center" ref={popupRef}>
                
                {/* Close button */}
                <div className="absolute top-4 right-4">
                    <FaTimes onClick={onClose} className="text-xl cursor-pointer text-white" />
                </div>

                {/* Heading */}
                <h1 className="font-outfit font-normal text-2xl lg:text-3xl mb-4 text-primary1">WAIT, ARE YOU SURE?</h1>

                {/* Subheading */}
                <hr className="w-full border-t border-secondary mb-4" />
                <div className="flex flex-col justify-center items-center text-center space-y-2">
                    <h3 className="font-outfit font-light text-xl lg:text-2xl text-primary1">
                        Please let us know why you do not want to continue?
                    </h3>
                    <p className="font-poppins font-light text-sm lg:text-base text-hcolor">
                        If you cancel now, your order details won’t be saved.
                    </p>
                </div>

                {/* Checkbox options */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 text-primary1 text-xs md:text-base font-poppins py-8">
                    {options.length > 0 ? (
                       options.map((option, index) => (
                        <label key={index} className="flex items-center space-x-3">
                            <input
                                type="checkbox"
                                className="w-5 h-5 min-w-[20px] min-h-[20px] accent-primary1 cursor-pointer"
                                checked={selected.includes(option.reason)}
                                onChange={() => handleCheckboxChange(option.reason)}
                            />
                            <span>{option.reason}</span>
                        </label>
                    ))
                    
                    ) : (
                        <p className="text-gray-400 text-sm">Loading reasons...</p>
                    )}
                </div>

                {/* Other Reason Input */}
                {selected.includes("Other") && (
                    <div className="w-full relative my-4">
                        <input
                            type="text"
                            placeholder="Tell us what changed your mind"
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            className="w-full h-[150px] p-2 pt-3 border bg-tertiary border-primary1 rounded-lg focus:border-2 focus:text-hcolor placeholder:text-start placeholder:align-top placeholder:text-xs"
                            required
                        />
                        <label className="absolute left-3 px-2 bg-tertiary text-primary1 text-lg font-outfit transform -translate-y-4 scale-75 top-1 z-10">
                            <span className="font-medium">OTHER</span> <span className="font-light">(please specify)</span>
                        </label>
                    </div>
                )}

                {/* Cancel Order Button */}
                <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
                    <button
                        type="submit"
                        className="w-full my-3 py-3 bg-hcolor text-tertiary text-base md:text-lg hover:border-2 hover:text-hcolor hover:bg-tertiary transition"
                        onClick={handleCancelAndExit}
                    >
                        CANCEL ORDER AND EXIT
                    </button>
                </div>  
            </div>
        </div>
    );
};

export default ReasonPopup;









// import React, { useState, useEffect , useRef} from "react";
// import { FaTimes } from "react-icons/fa";
// import { useNavigate, useLocation } from "react-router-dom"; 

// const ReasonPopup = ({ onClose }) => {  
//     const navigate = useNavigate();  
//     const location = useLocation(); 
//     const [selected, setSelected] = useState([]);
//     const [otherReason, setOtherReason] = useState("");


//     useEffect(() => {
//         // Disable scrolling when modal opens
//         document.body.style.overflow = "hidden";

//         return () => {
//             // Re-enable scrolling when modal closes
//             document.body.style.overflow = "auto";
//         };
//     }, []);
//     const popupRef = useRef(null);
//      useEffect(() => {
//           // Function to handle click outside
//           const handleClickOutside = (event) => {
//             if (popupRef.current && !popupRef.current.contains(event.target)) {
//              onClose();
//             }
//           };
      
//           document.addEventListener("mousedown", handleClickOutside);
//           return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//           };
//         }, [onClose]);
    

//     const options = [
//         "Have issue with coupons",
//         "I don’t want to give my mobile number",
//         "I have issue with address",
//         "I want to add/modify items in my cart",
//         "This Doesn't feel like brand site",
//         "Not sure of return/cancellation policy",
//         "Found the product at a better price elsewhere",
//         "Other",
//     ];

//     const handleCheckboxChange = (option) => {
//         setSelected((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     const handleCancelAndExit = () => {
//         if (selected.length === 0) {
//             alert("Please select a reason before exiting.");
//             return;
//         }

//         if (selected.includes("Other") && otherReason.trim() === "") {
//             alert("Please specify your reason in the text field.");
//             return;
//         }

//         onClose(); // Close the modal
//         navigate("/cart"); // Redirect user to the shop page
//     };


//     return (
//         <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-scroll backdrop-blur-sm rounded px-10">
//         <div className="bg-tertiary py-5 px-11 md:py-10 md:px-14 rounded md:w-[90%]  xl:w-[60%] relative top-16 md:top-10  text-center" ref={popupRef}>
                
//                 {/* Close button */}
//                 <div className="absolute top-4 right-4">
//                     <FaTimes onClick={onClose} className="text-xl cursor-pointer text-white" />
//                 </div>

//                 {/* Centered Heading */}
//                 <h1 className="font-outfit font-normal text-2xl lg:text-3xl mb-4 text-primary1">WAIT, ARE YOU SURE?</h1>

//                 {/* Horizontal line */}
//                 <hr className="w-full border-t border-secondary mb-4" />

//                 {/* Centered SubHeadings */}
//                 <div className="flex flex-col justify-center items-center text-center space-y-2">
//                     <h3 className="font-outfit font-light text-xl lg:text-2xl text-primary1">
//                         Please let us know why you do not want to continue?
//                     </h3>
//                     <p className="font-poppins font-light text-sm lg:text-base text-hcolor">
//                         If you cancel now, your order details won’t be saved.
//                     </p>
//                 </div>

//                 {/* Checkbox options */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 text-primary1 text-xs md:text-base font-poppins py-8">
//                     {options.map((option, index) => (
//                         <label key={index} className="flex items-center space-x-3">
//                             <input
//                                 type="checkbox"
//                                 className="w-5 h-5 min-w-[20px] min-h-[20px] accent-primary1 cursor-pointer"
//                                 checked={selected.includes(option)}
//                                 onChange={() => handleCheckboxChange(option)}
//                             />
//                             <span>{option}</span>
//                         </label>
//                     ))}
//                 </div>

//                 {/* Other Reason Input (Only Show When "Other" is Selected) */}
//                 {selected.includes("Other") && (
//                     <div className="w-full relative md: my-1 my-4">
//                         <input
//                             type="text"
//                             placeholder="Tell us what changed your mind"
//                             value={otherReason}
//                             onChange={(e) => setOtherReason(e.target.value)}
//                             className="w-full h-[150px] p-2 pt-3 border bg-tertiary border-primary1 rounded-lg focus:poppins focus:border-2 focus:text-hcolor placeholder:text-start placeholder:align-top placeholder:text-xs"
//                             required
//                         />
//                         {/* <label className="absolute left-3 px-2 bg-tertiary text-primary1 text-lg font-medium transform -translate-y-4 scale-75 top-1 z-10">
//                             OTHER (please specify)
//                         </label> */}
//                         <label className="absolute left-3 px-2 bg-tertiary text-primary1 text-lg font-outfit transform -translate-y-4 scale-75 top-1 z-10">
//                             <span className="font-medium">OTHER</span> <span className="font-light">(please specify)</span>
//                         </label>
//                     </div>
//                 )}
//                 {/* Cancel Order Button */}
//                 <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
//                     <button
//                     type="submit"
//                     className="w-full my-3 py-3 bg-hcolor text-tertiary text-base md:text-lg hover:border-2 hover:text-hcolor hover:bg-tertiary transition"
//                     onClick={handleCancelAndExit} // Handle exit and redirection
//                     >
//                         CANCEL ORDER AND EXIT
//                     {/* {isBilling ? "UPDATE BILLING ADDRESS" : "UPDATE SHIPPING ADDRESS"} */}
//                     </button>
//                 </div>  
//                 </div>
//         </div>
//     );
// };

// export default ReasonPopup;
